import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "teams-view-wrapper"
};
var _hoisted_2 = {
  class: "teams-container w-100 h-100 d-flex fl-j-c fl-a-c"
};
var _hoisted_3 = {
  key: 0,
  class: "left w-50 h-100 d-flex fl-col fl-s-b"
};
var _hoisted_4 = {
  class: "swiper-wrapper fl-a-c"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "f-small"
};
var _hoisted_7 = {
  class: "bottom d-flex fl-col fl-s-b fl-a-c"
};
var _hoisted_8 = {
  class: "w-100"
};
var _hoisted_9 = {
  class: "pb-10 f-large"
};
var _hoisted_10 = {
  class: "input-label w-100 d-flex fl-s-b fl-a-c"
};
var _hoisted_11 = {
  class: "input-label w-100 d-flex fl-s-b fl-a-c"
};
var _hoisted_12 = {
  class: "buttons w-100 d-flex fl-col fl-a-c"
};
var _hoisted_13 = {
  class: "right w-50 h-100"
};
var _hoisted_14 = {
  class: "content d-flex fl-j-c fl-a-c fl-col f-large"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  key: 1
};
var _hoisted_17 = {
  class: "card-icon d-flex fl-col fl-s-b fl-a-c"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$teamsArray$_ctx$, _ctx$teamsArray$_ctx$2, _ctx$teamsArray$_ctx$3;

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_swiper_slide = _resolveComponent("swiper-slide");

  var _component_swiper = _resolveComponent("swiper");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    class: "close-button",
    circle: "",
    onClick: _withModifiers(_ctx.close, ["stop"])
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.closeIcon,
        iconAlt: "close",
        iconStyle: "width: 20px; height: auto;",
        class: "close-icon"
      }, null, 8, ["iconContent"])];
    }),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.isLoading ? 'overlay w-100 h-100' : '')
  }, null, 2), _ctx.teamsArray.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_swiper, {
    modules: _ctx.modules,
    "slides-per-view": 6,
    "space-between": 10,
    "centered-slides": false,
    freeMode: true,
    navigation: true,
    virtual: "",
    ref: "swiper",
    onSwiper: _ctx.setSwiperRef
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamsArray, function (team, index) {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          key: index,
          virtualIndex: index,
          class: "d-flex fl-s-b fl-a-c"
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", {
              class: _normalizeClass("team d-flex fl-col fl-s-b ".concat(_ctx.currentTeam === index ? 'selected' : '')),
              onClick: _withModifiers(function ($event) {
                return _ctx.selectTeam(index);
              }, ["stop"])
            }, [_createElementVNode("h3", null, _toDisplayString("".concat(_ctx.$t("teams.team"), " ").concat(index + 1)), 1), _createElementVNode("p", _hoisted_6, _toDisplayString("".concat(team.roomPlayers, " ").concat(team.roomPlayers > 1 ? _ctx.$t("teams.players") : _ctx.$t("teams.player"))), 1), _createElementVNode("p", {
              class: "f-small",
              style: _normalizeStyle({
                color: team.paired ? '#00975F' : '#FF5630'
              })
            }, _toDisplayString(team.paired ? _ctx.$t("teams.paired") : _ctx.$t("teams.unpaired")), 5)], 10, _hoisted_5), _createVNode(_component_el_divider, {
              direction: "vertical"
            })];
          }),
          _: 2
        }, 1032, ["virtualIndex"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modules", "onSwiper"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString("".concat(_ctx.teamsArray[_ctx.currentTeam].roomPlayers, " ").concat(_ctx.teamsArray[_ctx.currentTeam].roomPlayers > 1 ? _ctx.$t("teams.players") : _ctx.$t("teams.player"))), 1), _createVNode(_component_el_form, {
    ref: "formRef",
    model: _ctx.form
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_10, [_createElementVNode("label", null, _toDisplayString(_ctx.$t("teams.name")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t("custom-fields.mandatory").toUpperCase()), 1)]), _createVNode(_component_el_form_item, {
        prop: "name"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.form.name = $event;
            }),
            placeholder: _ctx.$t('teams.placeholder'),
            size: "large"
          }, null, 8, ["modelValue", "placeholder"])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createElementVNode("label", null, _toDisplayString(_ctx.$t("teams.level")), 1)]), _createVNode(_component_el_form_item, {
        prop: "level"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: _ctx.form.level,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _ctx.form.level = $event;
            }),
            placeholder: _ctx.$t('teams.select-level'),
            size: "large"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelOptions, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_12, [!_ctx.teamsArray[_ctx.currentTeam].paired ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    disabled: !_ctx.form.name,
    class: "button w-100 py-5",
    type: "primary",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.scanAndPair();
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.pair-team")), 1)];
    }),
    _: 1
  }, 8, ["disabled"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    disabled: !_ctx.teamsArray[_ctx.currentTeam].paired,
    class: "button w-100 py-5",
    type: "primary",
    onClick: _ctx.proceed
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
    }),
    _: 1
  }, 8, ["disabled", "onClick"])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_ctx.isLoading ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("teams.pairing")), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString((_ctx$teamsArray$_ctx$ = _ctx.teamsArray[_ctx.currentTeam]) !== null && _ctx$teamsArray$_ctx$ !== void 0 && _ctx$teamsArray$_ctx$.paired ? _ctx.$t("teams.paired-successfully") : _ctx.$t("teams.get-ready")), 1)), _createElementVNode("div", _hoisted_17, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.cardsIcon,
    iconAlt: "card-icon",
    iconStyle: "width: 200px; height: auto;"
  }, null, 8, ["iconContent"]), _ctx.isLoading ? (_openBlock(), _createBlock(_component_SvgIcon, {
    key: 0,
    iconContent: _ctx.arrowDownIcon,
    iconAlt: "arrow-down",
    iconStyle: "width: 152px; height: auto;"
  }, null, 8, ["iconContent"])) : _createCommentVNode("", true), (_ctx$teamsArray$_ctx$2 = _ctx.teamsArray[_ctx.currentTeam]) !== null && _ctx$teamsArray$_ctx$2 !== void 0 && _ctx$teamsArray$_ctx$2.paired ? (_openBlock(), _createBlock(_component_SvgIcon, {
    key: 1,
    iconContent: _ctx.successIcon,
    iconAlt: "info",
    iconStyle: "width: 80px; height: auto;",
    class: "success-icon"
  }, null, 8, ["iconContent"])) : _createCommentVNode("", true)]), (_ctx$teamsArray$_ctx$3 = _ctx.teamsArray[_ctx.currentTeam]) !== null && _ctx$teamsArray$_ctx$3 !== void 0 && _ctx$teamsArray$_ctx$3.paired ? (_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    onClick: _ctx.unpair,
    class: "unpair-button f-large",
    type: "text"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.unpair")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])])])]);
}